import { render } from "./MisRecibos.vue?vue&type=template&id=1589a5cb&scoped=true"
import script from "./MisRecibos.vue?vue&type=script&lang=js"
export * from "./MisRecibos.vue?vue&type=script&lang=js"

import "./MisRecibos.vue?vue&type=style&index=0&id=1589a5cb&lang=scss&scoped=true"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1589a5cb"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QBtn,QTd});
